var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('h2',{staticClass:"subtitle has-text-centered"},[_vm._v("Qualifio SSO")]),_c('p',{staticClass:"has-text-centered mb-20"}),_c('action-list',{attrs:{"actions":_vm.managerActions}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }